import { RefObject, useEffect } from "react";
import { TabsRef } from "../Tabs";

interface IUseActionsContent {
  tabsRef: RefObject<TabsRef>;
  constructionSiteId: number | null;
}

const useActionsContent = ({
  tabsRef,
  constructionSiteId,
}: IUseActionsContent) => {

  useEffect(() => {
    if (!!tabsRef.current) {
      if (constructionSiteId) {
        tabsRef.current.onActiveTab("constructionSite");
      } else {
        tabsRef.current.onActiveTab("allConstructionSites");
      }
    }
  }, [constructionSiteId, tabsRef]);

  return {};
}

export default useActionsContent;
